/**
 *  @class
 *  @function ThemeCart
 */
if (!customElements.get('theme-cart')) {
  const debounce = (fn, wait) => {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  };
  class ThemeCart extends HTMLElement {

    constructor() {
      super();
    }
    connectedCallback() {
      if (this._initialized) return;
      this._initialized = true;
      this.setupEventListeners();
    }

    disconnectedCallback() {
      document.removeEventListener('cart:refresh', this._onCartRefresh);
      this.removeEventListener('change', this._debouncedOnChange);
      this.removeEventListener('click', this._onRemoveClick);
    }
    onChange(event) {
      if (event.target.type == 'number') {
        this.updateQuantity(event.target.dataset.index, event.target.value);
      } else if (event.target.getAttribute('id') == 'CartSpecialInstructions') {
        this.saveNotes();
      }
    }
    saveNotes() {
      fetch(`${theme.routes.cart_update_url}.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': `application/json`
        },
        body: JSON.stringify({
          'note': this.querySelector('#CartSpecialInstructions').value
        })
      });
    }
    setupEventListeners() {
      this._debouncedOnChange = debounce((event) => {
        this.onChange(event);
      }, 300);

      this._onCartRefresh = () => {
        this.refresh();
      };

      this._onRemoveClick = (event) => {
        const remove = event.target.closest('.remove');
        if (!remove) return;
        event.preventDefault();
        this.updateQuantity(remove.dataset.index, '0');
      };

      document.addEventListener('cart:refresh', this._onCartRefresh);
      this.addEventListener('change', this._debouncedOnChange);
      this.addEventListener('click', this._onRemoveClick);
    }
    getSectionsToRender() {
      return [
        {
          id: 'Cart',
          section: 'main-cart',
          selector: '.cart-items--items'
        },
        {
          id: 'Cart',
          section: 'main-cart',
          selector: '.thb-cart-form--cart-collaterals'
        },
        {
          id: 'cart-drawer-toggle',
          section: 'cart-bubble',
          selector: '.thb-item-count'
        }
      ];
    }
    displayErrors(line, message) {
      const lineItemError =
        document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
      if (lineItemError) {
        lineItemError.removeAttribute('hidden');
        lineItemError.querySelector('.cart-item__error-text').innerHTML = message;
        this.querySelector(`#CartItem-${line}`).classList.remove('loading');
      }
    }
    getSectionInnerHTML(html, selector) {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }
    updateQuantity(line, quantity) {

      this.classList.add('cart-disabled');
      if (line) {
        this.querySelector(`#CartItem-${line}`).classList.add('loading');
      }

      const body = JSON.stringify({
        line,
        quantity,
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname
      });
      dispatchCustomEvent('line-item:change:start', {
        quantity: quantity
      });
      fetch(`${theme.routes.cart_change_url}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': `application/json`
        },
        ...{
          body
        }
      })
        .then((response) => {
          return response.text();
        })
        .then((state) => {
          const parsedState = JSON.parse(state);


          if (parsedState.errors) {
            this.displayErrors(line, parsedState.errors);
            this.classList.remove('cart-disabled');
            return;
          }

          this.renderContents(parsedState, line, false);

           // ✅ 在这里广播 cart 变化
          dispatchCustomEvent('cart:change', {
            variantIds: parsedState.items.map(item => item.id.toString())
          });

          this.classList.remove('cart-disabled');

          dispatchCustomEvent('line-item:change:end', {
            quantity: quantity,
            cart: parsedState
          });
        });
    }
    refresh() {
      this.classList.add('cart-disabled');

      let sections = 'main-cart';

      fetch(`${window.location.pathname}/?sections=${sections}`)
        .then((response) => {
          return response.text();
        })
        .then((state) => {
          const parsedState = JSON.parse(state);


          if (parsedState.errors) {
            this.classList.remove('cart-disabled');
            return;
          }

          this.renderContents(parsedState, false, true);

           // ✅ refresh 也要同步 cart 状态
          dispatchCustomEvent('cart:change', {
            variantIds: parsedState.items.map(item => item.id.toString())
          });

          this.classList.remove('cart-disabled');
        });
    }
    renderContents(parsedState, line, refresh) {
      this.getSectionsToRender().forEach((section => {
        const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

        if (refresh) {
          if (parsedState[section.section]) {
            elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState[section.section], section.selector);
          }
        } else {
          elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        }

        if (line && this.querySelector(`#CartItem-${line}`)) {
          this.querySelector(`#CartItem-${line}`).classList.remove('loading');
        }
      }));
    }
  }
  customElements.define('theme-cart', ThemeCart);
}
